import { Box, Button, IconButton, Rating, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import axios from "axios";
import { API_URL } from "./Constant";

const MalayalamGrid = ({
  highlightedBox,
  onCellClick,
  questions,
  userAnswer,
  setHighlightedBox,
  setUserAnswer,
  setAllGridData,
  allGridData,
}) => {
  // const [highlightedBox, setHighlightedBox] = useState(null);
  const [isWin, setIsWin] = useState(false);
  const [playerPosition, setPlayerPosition] = useState(null);
  const [currentPosition, setCurrentPosition] = useState(null);
  const [gameResults, setGameResults] = useState([]);

  const finishGame = async () => {
    const playerId = localStorage.getItem("PlayerId");
    console.log("playerPosition", playerPosition);
    if (playerPosition !== null) {
      try {
        const response = await axios.post(`${API_URL}/insert_winner_details`, {
          game_id: "game1",
          player_id: playerId,
          position: playerPosition,
        });
        console.log(response.data);
      } catch (error) {
        console.error("Error fetching publishing time:", error);
      }
    }
  };

  useEffect(() => {
    const fetchPublishingTime = async () => {
      try {
        const response = await axios.post(`${API_URL}/winner_details`, {
          game_id: "game1",
        });
        console.log("cuurentposition", currentPosition);
        if (response.data.length > 0) {
          setCurrentPosition(response.data);
        } else {
          setCurrentPosition(null);
        }
      } catch (error) {
        console.error("Error fetching publishing time:", error);
      }
    };

    // Fetch publishing time initially
    fetchPublishingTime();

    // Set up a timer to fetch every minute
    const interval = setInterval(() => {
      fetchPublishingTime();
    }, 1000); // 60000ms = 1 minute

    return () => clearInterval(interval); // Clean up the interval when the component unmounts
  }, []);

  useEffect(() => {
    if (highlightedBox && userAnswer) {
      const updatedGrid = updateGridWithUserAnswer();
      setAllGridData(updatedGrid);
      const timer = setTimeout(() => {
        incrementQuestionNumber(highlightedBox.question_number);
      }, 1000);
      return () => clearTimeout(timer);
    }
    console.log(allGridData);
  }, [userAnswer, highlightedBox]);

  useEffect(() => {
    if (highlightedBox && userAnswer) {
      const unansweredQuestions = questions.filter((q) => {
        const questionNumber = q.question_number;
        const questionInGrid = findCellForQuestion(questionNumber);
        if (questionInGrid) {
          const { row, col } = questionInGrid;
          const cell = allGridData[row][col];
          return cell.answer === ""; // If the answer is empty, it is unanswered
        }
        return false;
      });
      // console.log('unansweredQuestions.length',unansweredQuestions.length)
      // Sort unanswered questions by question number (ascending)
      if (unansweredQuestions.length === 0) {
        setPlayerPosition("First");
        if (currentPosition.length === null) {
          if (currentPosition === 1) {
            setPlayerPosition("Second");
          } else if (currentPosition === 2) {
            setPlayerPosition("Thired");
          } else {
            setPlayerPosition(null);
          }
        }
        setIsWin(true);
        finishGame();
      }
    }
  }, [userAnswer, highlightedBox, allGridData]);

  const updateGridWithUserAnswer = () => {
    // Deep copy of the grid
    const updatedGrid = allGridData.map((row) =>
      row.map((cell) => ({ ...cell })),
    );

    if (!highlightedBox || !userAnswer) return updatedGrid;

    const answerLetters = Array.isArray(userAnswer)
      ? userAnswer
      : typeof userAnswer === "string"
        ? userAnswer.split(",")
        : [];

    const { direction, question_number } = highlightedBox;

    let currentRow, currentCol;

    // Locate the starting position for the highlighted question
    let found = false;
    for (let r = 0; r < updatedGrid.length && !found; r++) {
      for (let c = 0; c < updatedGrid[r].length; c++) {
        if (updatedGrid[r][c].value === String(question_number)) {
          currentRow = r;
          currentCol = c;
          found = true;
          break;
        }
      }
    }

    if (!found) return updatedGrid; // If starting position not found, return grid as is

    // Update grid with answer letters
    for (const letter of answerLetters) {
      // Ensure we're within bounds
      if (
        currentRow < updatedGrid.length &&
        currentCol < updatedGrid[currentRow]?.length
      ) {
        const cell = updatedGrid[currentRow][currentCol];

        // Update the cell's answer
        cell.answer = letter;

        // Move to the next cell in the specified direction
        if (direction === "across") currentCol++;
        else if (direction === "down") currentRow++;
      }
    }

    return updatedGrid;
  };

  const incrementQuestionNumber = (currentQuestionNumber) => {
    console.log("currentQuestionNumber", currentQuestionNumber);
    const questionNumbers = questions.map(
      (question) => question.question_number,
    );
    const maxQuestionNumber = Math.max(...questionNumbers);
    let nextQuestionNumber;
    if (currentQuestionNumber === maxQuestionNumber) {
      const unansweredQuestions = questions.filter((q) => {
        const questionNumber = q.question_number;
        const questionInGrid = findCellForQuestion(questionNumber);
        if (questionInGrid) {
          const { row, col } = questionInGrid;
          const cell = allGridData[row][col];
          return cell.answer === ""; // If the answer is empty, it is unanswered
        }
        return false;
      });
      if (unansweredQuestions.length > 0) {
        const nextUnansweredQuestion = unansweredQuestions.reduce(
          (min, question) =>
            min.question_number < question.question_number ? min : question,
        );
        nextQuestionNumber = nextUnansweredQuestion.question_number;
      } else {
        setIsWin(true);
      }
    } else {
      if (isQuestionAnswered(currentQuestionNumber + 1)) {
        const unansweredQuestions = questions.filter((q) => {
          const questionNumber = q.question_number;
          const questionInGrid = findCellForQuestion(questionNumber);
          if (questionInGrid) {
            const { row, col } = questionInGrid;
            const cell = allGridData[row][col];
            return cell.answer === ""; // If the answer is empty, it is unanswered
          }
          return false;
        });
        if (unansweredQuestions.length > 0) {
          const nextUnansweredQuestion = unansweredQuestions.reduce(
            (min, question) =>
              min.question_number < question.question_number ? min : question,
          );
          nextQuestionNumber = nextUnansweredQuestion.question_number;
        } else {
          setPlayerPosition("First");
          if (currentPosition === 0) {
            if (currentPosition === 1) {
              setPlayerPosition("Second");
            } else if (currentPosition === 2) {
              setPlayerPosition("Thired");
            } else {
              setPlayerPosition(null);
            }
          }
          setIsWin(true);
          finishGame();
          setIsWin(true);
        }
      } else {
        nextQuestionNumber = currentQuestionNumber + 1;
      }
    }
    console.log("nextQuestionNumber", nextQuestionNumber);
    setHighlightedBox((prevState) => ({
      ...prevState,
      question_number: "",
      direction: "",
      question_text: "",
      answer: "",
      length: "",
    }));
    setUserAnswer("");
    // Find the next question details
    const nextQuestion = questions?.find(
      (q) => q.question_number === nextQuestionNumber,
    );

    if (nextQuestion) {
      const { question_number, direction, question_text, answer, length } =
        nextQuestion;

      // Update the highlightedBox with the new question details
      const found = findCellForQuestion(nextQuestionNumber);
      if (found) {
        onCellClick({
          question_number,
          direction,
          question_text,
          answer,
          length,
        });
      }
    }
  };

  const isQuestionAnswered = (questionNumber) => {
    const questionInGrid = findCellForQuestion(questionNumber); // Locate the grid cell for the question
    if (questionInGrid) {
      const { row, col } = questionInGrid;
      const cell = allGridData[row][col]; // Access the cell data
      return cell.answer !== ""; // Check if the cell's answer is not empty
    }
    return false; // Return false if the question is not in the grid
  };

  const findCellForQuestion = (questionNumber) => {
    for (let r = 0; r < allGridData.length; r++) {
      for (let c = 0; c < allGridData[r].length; c++) {
        if (allGridData[r][c].value === String(questionNumber)) {
          return { row: r, col: c };
        }
      }
    }
    return null;
  };

  const handleCellClick = (rowIndex, cellIndex, cellValue) => {
    console.log(rowIndex, cellIndex);

    // Clear previous highlights
    setHighlightedBox((prevState) => ({
      ...prevState,
      question_number: "",
      direction: "",
      question_text: "",
      answer: "",
      length: "",
    }));
    setUserAnswer("");

    // Check if clicked cell has a value (i.e., a valid question number)
    if (cellValue && cellValue.trim() !== "") {
      // Find the question that matches the cell value (matching by question number)
      const questionForValue = questions?.find(
        (q) => q.question_number.toString() === cellValue.trim(),
      );

      console.log("Question for Value:", questionForValue);

      // If question found, pass it to onCellClick
      if (questionForValue) {
        onCellClick({
          question_number: questionForValue.question_number,
          direction: questionForValue.direction,
          question_text: questionForValue.question_text,
          answer: questionForValue.answer,
          length: questionForValue.length,
        });
        return; // Stop further execution if a question was found
      }
    } else {
      const questionForValue = findCellForQuestionByAnswer(rowIndex, cellIndex);
      if (questionForValue) {
        onCellClick({
          question_number: questionForValue.question_number,
          direction: questionForValue.direction,
          question_text: questionForValue.question_text,
          answer: questionForValue.answer,
          length: questionForValue.length,
        });
        return;
      }
    }
    // Otherwise, find the first matching question for the cell (if no value)
    const question = questions?.find(
      (q) => q.row_index === rowIndex && q.col_index === cellIndex,
    );

    console.log("Fallback Question:", question);

    if (question) {
      onCellClick({
        question_number: question.question_number,
        direction: question.direction,
        question_text: question.question_text,
        answer: question.answer,
        length: question.length,
      });
    }
  };

  const findCellForQuestionByAnswer = (rowIndex, cellIndex) => {
    return questions?.find((q) => {
      const startRow = q.row_index;
      const startCol = q.col_index;
      const length = q.length;

      if (q.direction === "across") {
        return (
          rowIndex === startRow &&
          cellIndex >= startCol &&
          cellIndex < startCol + length
        );
      } else if (q.direction === "down") {
        return (
          cellIndex === startCol &&
          rowIndex >= startRow &&
          rowIndex < startRow + length
        );
      }
      return false;
    });
  };

  const renderGrid = () => {
    return allGridData.map((row, rowIndex) => (
      <tr key={rowIndex}>
        {row.map((cell, cellIndex) => (
          <td
            key={cellIndex}
            className={`grid-cell ${cell.visible ? "visible" : "hidden"} ${
              highlightedBox &&
              highlightedBox.row === rowIndex &&
              highlightedBox.col === cellIndex
                ? "active"
                : ""
            }`}
            onClick={() =>
              handleCellClick(rowIndex, cellIndex, cell.value || "")
            }
          >
            {cell.visible && (
              <div>
                {cell.value && <span className="cell-value">{cell.value}</span>}
                {cell.answer && (
                  <span className="cell-answer">{cell.answer}</span>
                )}
              </div>
            )}
          </td>
        ))}
      </tr>
    ));
  };

  return (
    <div>
      <table className="crossword-grid">
        <tbody>{renderGrid()}</tbody>
        {isWin && (
          <Box
            sx={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              backgroundColor: "rgba(0, 0, 0, 0.6)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              zIndex: "1000",
            }}
          >
            <Box
              sx={{
                width: { md: "25%", sm: "35%", xs: "75%" },
                backgroundColor: "#ffffff",
                borderRadius: "8px",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                overflow: "hidden",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                padding: "24px",
              }}
            >
              {/* Close Button */}
              <Box
                sx={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "flex-end",
                  mb: 2,
                }}
              >
                <IconButton
                  onClick={() => {
                    setIsWin(false); // Reset the game state
                    window.location.reload(); // Refresh the page
                  }}
                  sx={{
                    color: "#6b6b6b",
                    "&:hover": {
                      color: "#000000",
                    },
                  }}
                >
                  <CloseOutlinedIcon />
                </IconButton>
              </Box>

              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: "20px",
                  color: "#333333",
                  textAlign: "center",
                  mb: 2,
                }}
              >
                🎉 Congratulations! 🎉
              </Typography>

              <Typography
                sx={{
                  fontWeight: 400,
                  fontSize: "16px",
                  color: "#555555",
                  textAlign: "center",
                }}
              >
                {playerPosition === "First"
                  ? "You have successfully completed the crossword puzzle. You are placed in FIRST POSITION!"
                  : playerPosition === "Second"
                    ? "You have successfully completed the crossword puzzle. You are placed in SECOND POSITION!"
                    : playerPosition === "Thired"
                      ? "You have successfully completed the crossword puzzle. You are placed in THIRED POSITION!"
                      : "You have successfully completed the crossword puzzle. Great job!"}
              </Typography>

              {/* Action Button */}
              <Box
                sx={{
                  marginTop: "24px",
                  display: "flex",
                  justifyContent: "center",
                  width: "100%",
                }}
              ></Box>
            </Box>
          </Box>
        )}
      </table>

      <style jsx>{`
        .crossword-grid {
          margin-top: 16px;
          border-collapse: collapse;
          width: 100%;
        }

        .grid-cell {
          border: 1px solid #376694;
          width: 48px;
          height: 48px;
          position: relative;
          text-align: center;
          vertical-align: middle;
          font-size: 14px;
          background-color: #333333; /* Dark background for grid */
          cursor: pointer;
          transition: background-color 0.3s ease;
        }

        .grid-cell.hidden {
          background-color: #f1f3fc; /* Hidden cells are white */
          border: none;
        }

        .grid-cell.visible {
          background-color: #f8f8ff; /* Light color for visible cells */
        }

        .grid-cell.visible.active {
          background-color: #c7d9e7; /* Active cells are light blue */
        }

        .grid-cell.visible:hover {
          background-color: #98dbd6; /* blue hover effect for active cells */
        }

        .cell-value {
          position: absolute;
          top: 5%;
          left: 5%;
          font-size: 10px;
          color: #000;
        }

        .cell-answer {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          font-size: 14px;
          color: #000;
          font-weight: bold;
        }

        /* Responsive design for the modal */
        @media screen and (max-width: 600px) {
          .grid-cell {
            width: 40px;
            height: 40px;
          }
        }
      `}</style>
    </div>
  );
};

export default MalayalamGrid;
